import {Base} from "@/api/Base"

export class ServiceProviderList extends Base {
    path = "serviceProvider/list"
}